import './scripts/common';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

import * as filterCounter from './scripts/filter-counter';
filterCounter.init();

//bootstrap imports
import Collapse from 'bootstrap/js/dist/collapse';

import * as accordion from './scripts/accordion.js';
accordion.init();

import * as imageGallerySlider from './scripts/image-gallery-slider';
imageGallerySlider.init();

// Content-teaser-slider
import * as genericSlider from './scripts/generic-slider';
genericSlider.init();

// Reference Slider
import * as teaserSliderLg from './scripts/teaser-slider-lg';
teaserSliderLg.init();

import * as lightbox from '@elements/lightbox';
lightbox.init();

// Product Slider
import * as productGenericSlider from './scripts/product-generic-slider';
productGenericSlider.init();

import * as tabs from './scripts/tabs';
tabs.init();

import * as logoSlider from './scripts/logo-slider';
logoSlider.init();

import * as factArea from './scripts/fact-area';
factArea.init();